import React, {Component} from 'react';
import {TextField, TextAreaField, SelectField, FormSection} from '../../components/FormFields';
import Button, {ButtonGroup} from '@atlaskit/button';
import {FormFooter} from '@atlaskit/form';
import {Grid, GridColumn} from '@atlaskit/page';
import ContentWrapper from '../../components/ContentWrapper';
import {connect} from 'react-redux';
import DealerActions from '../../redux/DealerRedux';
import DictionariesActions from '../../redux/DictionariesRedux';
import Forbidden from '../../components/Forbidden';
import {withTranslation, Trans} from 'react-i18next';

class DealerPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      region: null, //fix issue: не работаtт deaultValue для select
      cities: null,
      dealer: {
        name: '',
        city: null,
        address: '',
        inn: '',
        kpp: '',
        salesPhone: '',
        stoPhone: '',
        webSite: '',
        email: '',
        description: ''
      },
    };
  }

  componentDidMount() {
    if (this.props.match.params.id !== 'new') {
      this.props.get(this.props.match.params.id);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.fetching !== this.props.fetching
      && prevProps.fetching) {
        if (!this.props.error) {
          if (prevProps.dealer
            && !this.props.dealer) {
              //дилер был удален
              this.props.history.goBack();
          } else if (this.props.match.params.id === 'new'
            && this.props.dealer) {
              //дилер был добавлен
              this.props.history.goBack();
          } else {
            //даные дилера загружены
            let data = {};
            Object.keys(this.state.dealer).map(key => data[key] = this.props.dealer[key])
            //const region = this.props.regions.find(region => region.value === this.props.dealer.city.region.id);
            this.setState({
              dealer: data,
              region: this.props.dealer.city.region,
              //cities: region ? [...region.cities] : null,
            });
          }
        
        } else if (!this.state.dealer.name) {
          //произошла ошибка - дилер не найден, другие ошибки выводим глобально
          this.props.history.goBack();
        }
    }
  }

  onDelete = e => {
    e.preventDefault();
    this.props.delete(this.props.dealer.id);
  }

  onCancel = e => {
    e.preventDefault();
    this.props.history.goBack();
  }

  onFormSubmit = e => {
    e.preventDefault();
    const {create, update} = this.props;
    const {dealer} = this.state;
    if (!dealer.city) {
      //waranty: Должен быть вывод ошибки, так как из required для select не работает.

    } else {
      this.props.match.params.id === 'new'
      ? create(dealer)
      : update({
        ...dealer,
        id: this.props.dealer.id
      });
    }
  }

  onChange = (name, value) => {
    this.setState({
      dealer: {...this.state.dealer, [name]: value},
    });
  }

  render() {
    const isNew = this.props.match.params.id === 'new';
    const {dealer, region} = this.state;
    const {
      dictionaries,
      getDictionaries,
      fetching,
      permissions,
      t,
    } = this.props;

    if (!permissions) {
      return <Forbidden />;
    } else if (isNew && !permissions.create) {
      return <Forbidden />
    }

    let cities = null;
    let currentRegion = null;
    if (dictionaries.regions.data && region) {
      currentRegion = dictionaries.regions.data.find(r => r.id === region.id);
      if (currentRegion) {
        cities = currentRegion.cities;
      }
    }
    const hideControl = !isNew && !permissions.edit;
    const disabled = hideControl || fetching;
    return (
      <ContentWrapper>
        <h1>{t(isNew ? 'Create new dealer' : 'Edit dealer')}</h1>
        <form onSubmit={this.onFormSubmit}>
          <Grid>
            <GridColumn medium={12}>
              <TextField
                name='name'
                label={t('Name')}
                required={true}
                onChange={this.onChange}
                placeholder={t("Enter dealer's name")}
                value={dealer.name}
              />
            </GridColumn>
            <GridColumn medium={6}>
              <SelectField
                name='region'
                label={t('Region')}
                required={true}
                placeholder={t('Select region')}
                value={currentRegion ? currentRegion : region}
                isDisabled={disabled || dictionaries.regions.fetching}
                data={dictionaries.regions.data}
                fetching={dictionaries.regions.fetching}
                getData={getDictionaries('regions')}
                onChange={(name, region) => {
                  this.setState({region});
                  this.onChange('city', null);
                }}
              />
            </GridColumn>
            <GridColumn medium={6}>
              <SelectField
                name='city'
                label={t('City')}
                required={true}
                placeholder={t('Select city')}
                data={cities}
                onChange={this.onChange}
                isClearable
                isDisabled={!cities || disabled}
                value={dealer.city}
              />
            </GridColumn>
            <GridColumn medium={12}>
              <TextField
                name='address'
                label={t('Address')}
                required={true}
                onChange={this.onChange}
                placeholder={t("Enter dealer's address")}
                isDisabled={disabled}
                value={dealer.address}
              />
            </GridColumn>
            <GridColumn medium={6}>
              <TextField
                name='inn'
                label={t('Tax ID')}
                required={true}
                onChange={this.onChange}
                placeholder={t('Enter tax ID')}
                isDisabled={disabled}
                value={dealer.inn}
              />
            </GridColumn>
            <GridColumn medium={6}>
              <TextField
                name='kpp'
                label={t('Tax ID2')}
                required={true}
                onChange={this.onChange}
                placeholder={t('Enter tax ID2')}
                isDisabled={disabled}
                value={dealer.kpp}
              />
            </GridColumn>

            <GridColumn medium={12}>
              <FormSection>{t('Contacts')}</FormSection>
            </GridColumn>
            <GridColumn medium={6}>
              <TextField
                name='salesPhone'
                label={t('Sales dept phone')}
                onChange={this.onChange}
                placeholder={t('Enter phone number')}
                isDisabled={disabled}
                value={dealer.salesPhone}
              />
            </GridColumn>
            <GridColumn medium={6}>
              <TextField
                name='stoPhone'
                label={t('Service dept phone')}
                onChange={this.onChange}
                placeholder={t('Enter service dept phone number')}
                isDisabled={disabled}
                value={dealer.stoPhone}
              />
            </GridColumn>
            <GridColumn medium={6}>
              <TextField
                name='webSite'
                label={t('Web site')}
                onChange={this.onChange}
                placeholder={t('Enter web site address')}
                isDisabled={disabled}
                value={dealer.webSite}
              />
            </GridColumn>
            <GridColumn medium={6}>
              <TextField
                name='email'
                label={t('E-mail')}
                onChange={this.onChange}
                placeholder={t('Enter e-mail')}
                isDisabled={disabled}
                value={dealer.email}
              />
            </GridColumn>
            <GridColumn medium={12}>
              <TextAreaField
                name='description'
                label={t('Company description')}
                onChange={this.onChange}
                isDisabled={disabled}
                value={dealer.description}
              />
            </GridColumn>
            <GridColumn>
              <FormFooter>
                <ButtonGroup>
                  {!isNew && permissions.delete && (
                    <Button
                      appearance='subtle'
                      isDisabled={fetching}
                      onClick={this.onDelete}
                    >
                      <span style={{color: !disabled && 'red'}}>
                        <Trans>Remove</Trans>
                      </span>
                    </Button>
                  )}
                  <Button appearance='subtle' isDisabled={fetching} onClick={this.onCancel}>
                    <Trans>Cancel</Trans>
                  </Button>
                  {!hideControl && (
                    <Button type='submit' isDisabled={disabled} isLoading={fetching} appearance='danger'>
                       <Trans>{isNew ? 'Create' : 'Save'}</Trans>
                    </Button>
                  )}
                </ButtonGroup>
              </FormFooter>
            </GridColumn>
          </Grid>
        </form>
      </ContentWrapper>
    );
  }
}
const mapStateToProps = state => {
  return {
    permissions: state.userProfile.permissions.dealer,
    dealer: state.dealer.data,
    fetching: state.dealer.fetching,
    error: state.dealer.error,
    dictionaries: state.dictionaries, 
  };
};

const mapDispatchToProps = dispatch => {
  return {
    get: id => dispatch(DealerActions.dealerRequest(id)),
    create: data => dispatch(DealerActions.dealerAddRequest(data)),
    update: data => dispatch(DealerActions.dealerUpdateRequest(data)),
    delete: id => dispatch(DealerActions.dealerDeleteRequest(id)),
    getDictionaries: name => () => dispatch(DictionariesActions.dictionariesRequest(name)),
  };
};

export default withTranslation('dealers', 'common')(connect(
  mapStateToProps,
  mapDispatchToProps,
)(DealerPage));
